import { DefaultRentPriceTypeOption } from '../../../../../../@types/dropdown-types'
import {
  RealEstatePrice,
  RealEstatePricePeriodTypeOption,
  RealEstatePriceTypeOption,
} from '../../../../../../@types/real-estate-api-types'
import { ContentStateInterface } from '../../../../../../@types/types'
import { DE, parseDecimal } from '../../../../../../i18next/decimal'

export type PriceToApiMapper = (insertionData: ContentStateInterface) => RealEstatePrice

const roundValue = (val: number): number => parseFloat(val.toFixed(2))
const formatValue = (val?: number): string | undefined => (val ? val.toFixed(2) : undefined)

const calculateTotalRent = (insertionData: ContentStateInterface): number | undefined => {
  return insertionData.price !== undefined && insertionData.price !== null
    ? roundValue(
        insertionData.price +
          (insertionData.additionalCosts ?? 0) +
          Number(parseDecimal(insertionData.heatingCosts, DE) ?? 0)
      )
    : undefined
}

export const priceToApiMonthlyRent: PriceToApiMapper = (insertionData: ContentStateInterface) => {
  const totalRent = calculateTotalRent(insertionData)

  return {
    monthlyRent: formatValue(insertionData.price),
    //total rent
    price: totalRent,
  }
}
export const priceToApiMonthlyRentWithManualTotalRent: PriceToApiMapper = (insertionData: ContentStateInterface) => {
  const totalRent = calculateTotalRent(insertionData)

  return {
    monthlyRent: formatValue(insertionData.price),
    //total rent
    price:
      insertionData.manualTotalRent === undefined ? totalRent : Number(parseDecimal(insertionData.manualTotalRent, DE)),
  }
}

export const priceToApiRent: PriceToApiMapper = (insertionData) => ({
  priceType:
    (insertionData.priceType?.value as RealEstatePriceTypeOption) ?? DefaultRentPriceTypeOption.RENT_PER_MONTH_PRICE,
  price: insertionData.price,
  baseRent: parseDecimal(insertionData.baseRent, DE),
})

export const priceToApiPlotRent: PriceToApiMapper = (insertionData) => ({
  priceType: (insertionData.priceType?.value as RealEstatePriceTypeOption) ?? undefined,
  price: insertionData.price,
  baseRent: parseDecimal(insertionData.baseRent, DE),
})

export const priceToApiShortTermRent: PriceToApiMapper = (insertionData) => ({
  pricePeriodType: insertionData.pricePeriodType?.value as RealEstatePricePeriodTypeOption,
  price: insertionData.price,
})

export const priceToApiSell: PriceToApiMapper = (insertionData) => ({
  priceType: (insertionData.priceType?.value as RealEstatePriceTypeOption) ?? RealEstatePriceTypeOption.PURCHASE_PRICE,
  price: insertionData.price,
})
